import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer0056 = new TileLayer({
  title: 'Máscara 20170929',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20170929l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0056.setVisible(false);
  
const layer0055 = new TileLayer({
  title: 'Máscara 20171007',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20171007l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0055.setVisible(false);

const layer0054 = new TileLayer({
  title: 'Máscara 20171015',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20171015l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0054.setVisible(false);
  
const layer0053 = new TileLayer({
  title: 'Máscara 20171023',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20171023l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0053.setVisible(false);
  
const layer0052 = new TileLayer({
  title: 'Máscara 20171031',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20171031l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0052.setVisible(false);
  
const layer0051 = new TileLayer({
  title: 'Máscara 20171108',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20171108l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0051.setVisible(false);
  
const layer0050 = new TileLayer({
  title: 'Máscara 20171116',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20171116l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0050.setVisible(false);
  
const layer0049 = new TileLayer({
  title: 'Máscara 20171202',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20171202l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0049.setVisible(false);
  
const layer0048 = new TileLayer({
  title: 'Máscara 20171218',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20171218l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0048.setVisible(false);
  
const layer0047 = new TileLayer({
  title: 'Máscara 20180119',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20180119l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0047.setVisible(false);
  
const layer0046 = new TileLayer({
  title: 'Máscara 20180127',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20180127l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0046.setVisible(false);
  
const layer0045 = new TileLayer({
  title: 'Máscara 20180220',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20180220l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0045.setVisible(false);
  
const layer0044 = new TileLayer({
  title: 'Máscara 20180417',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20180417l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0044.setVisible(false);
  
const layer0043 = new TileLayer({
  title: 'Máscara 20180503',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20180503l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0043.setVisible(false);
  
const layer0042 = new TileLayer({
  title: 'Máscara 20180706',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20180706l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0042.setVisible(false);
  
const layer0041 = new TileLayer({
  title: 'Máscara 20180722',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20180722l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0041.setVisible(false);

const layer0040 = new TileLayer({
  title: 'Máscara 20180730',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20180730l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0040.setVisible(false);

const layer0039 = new TileLayer({
  title: 'Máscara 20180823',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20180823l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0039.setVisible(false);
  
const layer0038 = new TileLayer({
  title: 'Máscara 20180831',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20180831l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0038.setVisible(false);

export const grupoCapa01_4 = new LayerGroup({
  title: 'Ciclo Hidrológico 2017-2018',
  fold: 'close',
  layers: [layer0038, layer0039, layer0040, layer0041, layer0042, layer0043, layer0044, layer0045, layer0046, layer0047, layer0048, layer0049, layer0050, layer0051, layer0052, layer0053, layer0054, layer0055,layer0056]
});